module.exports = {
      id: "apple-store-usage",
      viewBox: "0 0 132 40",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#apple-store",
      toString: function () {
        return this.url;
      }
    }